export enum ActivityType {
  Login = "LOGIN",
  Logout = "LOGOUT",
  DownloadPrescription = "DOWNLOAD PRESCRIPTION",
  CancelPrescription = "CANCEL PRESCRIPTION",
  ClonePrescription = "CLONE PRESCRIPTION",
  LockPrescription = "LOCK PRESCRIPTION",
  UnLockPrescription = "UNLOCK PRESCRIPTION",
  EditPrescription = "EDIT PRESCRIPTION",
  FillPrescription = "FILL PRESCRIPTION",
  PartiallyFillPrescription = "PARTIALLY FILL PRESCRIPTION",
  AddPatient = "ADD PATIENT",
  UpdatePatient = "UPDATE PATIENT",
  DeletePatient = "DELETE PATIENT",
  DoctorRegister = "DOCTOR REGISTERED",
  CreatePrescription = "CREATE PRESCRIPTION",
  AddDrug = "ADD DRUG",
  UpdateDrug = "UPDATE DRUG",
  DeleteDrug = "DELETE DRUG",
  AddUser = "ADD USER",
  UpdateUser = "UPDATE USER",
  DeleteUser = "DELETE USER",
  ActivateUser = "ACTIVATE USER",
  DeactivateUser = "DEACTIVATE USER",
  ResetPassword = "PASSWORD RESET",
  DoctorApproved = "APPROVE DOCTOR",
  DoctorReject = "REJECT DOCTOR",
  DoctorPasswordReset = "DOCTOR PASSWORD RESET",
  DoctorActivated = "ACTIVATE DOCTOR",
  DoctorDeActivated = "DEACTIVATE DOCTOR",
  NotCollected = "NOT COLLECTED"
}
